import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Loader2 } from 'lucide-react';
import { FilterState } from '../Filters';
import { trackFunnelStep3 } from '../../utils/analytics';

interface JobDescriptionStepProps {
  jobDescription: string;
  filters: FilterState;
  isLoading: boolean;
  onJobDescriptionChange: (text: string) => void;
  onFilterChange: (filters: FilterState) => void;
  onGenerate: () => void;
}

export default function JobDescriptionStep({
  jobDescription,
  filters,
  isLoading,
  onJobDescriptionChange,
  onFilterChange,
  onGenerate
}: JobDescriptionStepProps) {
  // Track page view when component mounts
  useEffect(() => {
    trackFunnelStep3.viewJobDescription();
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onJobDescriptionChange(e.target.value);
    trackFunnelStep3.inputJobDescription();
  };

  const handleGenerate = () => {
    trackFunnelStep3.submitJobDescription();
    onGenerate();
  };

  return (
    <div className="p-8 md:p-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 font-gabarito">
          Enter job description
        </h2>
        <p className="text-gray-600 text-center mb-8">
          Our AI tailors your application kit to the job, making you stand out
        </p>
        
        <div className="max-w-lg mx-auto space-y-6">
          <div>
            <textarea
              value={jobDescription}
              onChange={handleInputChange}
              className="w-full h-48 p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
              placeholder="Paste the job description here..."
            />
          </div>
          
          <div className="flex justify-center">
            <button
              onClick={handleGenerate}
              disabled={isLoading || !jobDescription}
              className="inline-flex items-center px-8 py-3 text-lg font-medium text-white bg-purple-gradient rounded-full hover:bg-purple-gradient-hover transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
            >
              {isLoading ? (
                <>
                  <Loader2 className="animate-spin mr-2 h-5 w-5" />
                  Generating...
                </>
              ) : (
                <>
                  Land Dream Job
                  <ArrowRight className="ml-2 w-5 h-5" />
                </>
              )}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}